import { getActiveLang } from '@openclassrooms/translations';

import { CourseJsonLD, CourseType, PartType, CourseDifficulty } from '../types';

type EducationalLevel = 'Beginner' | 'Intermediate' | 'Advanced';

const getEducationalLevel = (difficulty: CourseDifficulty): EducationalLevel => {
  const difficultyMap: Record<CourseDifficulty, EducationalLevel> = {
    Easy: 'Beginner',
    Medium: 'Intermediate',
    Hard: 'Advanced',
  };

  return difficultyMap[difficulty] || 'Beginner';
};

const getCourseJsonLD = (course: CourseType, userToc: PartType): CourseJsonLD | null => {
  if (!course || !userToc?.children) return null;

  const syllabusSections = userToc.children.map((section: PartType) => ({
    '@type': 'Syllabus' as const,
    name: section.title,
  }));

  return {
    '@context': 'https://schema.org',
    '@type': 'Course',
    name: course.title,
    description: course.shortDescription,
    provider: {
      '@type': 'Organization',
      name: 'OpenClassrooms',
      url: 'https://openclassrooms.com',
    },
    offers: {
      '@type': 'Offer',
      category: 'Free',
    },
    hasCourseInstance: [
      {
        '@type': 'CourseInstance',
        courseMode: 'Online',
        courseWorkload: course.duration,
        instructor: course.authors?.map((author) => ({
          '@type': 'Person',
          name: author.displayName,
          description: author.miniBiography,
          image: author.profilePicture,
        })),
      },
    ],
    educationalLevel: getEducationalLevel(course.difficulty),
    image: course.illustration,
    inLanguage: getActiveLang(),
    syllabusSections,
  };
};

export default getCourseJsonLD;
